import { render } from "./PasswordReset.vue?vue&type=template&id=28a53e2b&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=28a53e2b&scoped=true&lang=css"
import "./PasswordReset.vue?vue&type=style&index=1&id=28a53e2b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a53e2b"]])

export default __exports__